<template>
  <v-btn
    :color="color"
    :disabled="disabledComputed"
    @click="onClick"
    :outlined="outlinedComputed"
    :small="smallComputed"
    :text="styleText"
    :icon="iconProp"
    :depressed="depressed"
    :dark="dark"
    :block="block"
    height="30px"
  >
    <!-- アイコンを右側に -->
    <template v-if="right">
      {{ labelComputed }}
      <v-icon class="ml-2" v-if="iconComputed">{{ iconComputed }}</v-icon>
    </template>
    <!-- アイコンを左側に -->
    <template v-else>
      <v-icon class="mr-2" v-if="iconComputed">{{ iconComputed }}</v-icon>
      {{ labelComputed }}
    </template>
  </v-btn>
</template>

<script>
export default {
  name: 'Btn',

  components: {},

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    styleText: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconProp: {
      type: Boolean,
      required: false,
      default: false,
    },
    depressed: {
      type: Boolean,
      required: false,
      default: false,
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    block: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCheckRole: {
      // 編集、参照ロールチェックを実施するか判定
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {}
  },

  computed: {
    labelComputed() {
      return this.label
    },
    rightComputed() {
      return this.right
    },
    outlinedComputed() {
      return this.outlined
    },
    iconComputed() {
      return this.icon
    },
    smallComputed() {
      return this.small
    },
    disabledComputed() {
      return this.disabled || !this.canEdit
    },
    canEdit() {
      if (this.isCheckRole) {
        return this.$store.getters.hasEditRole
      } else {
        return true
      }
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
